import { LabelHTMLAttributes, forwardRef } from 'react';
import * as S from './styles';

const Frame = forwardRef<
  HTMLLabelElement | any,
  LabelHTMLAttributes<HTMLLabelElement> | any
>(({ children, width, ...rest }: any, ref) => {
  return (
    <S.Frame ref={ref} width={width} {...rest}>
      {children}
    </S.Frame>
  );
});

Frame.displayName = 'Frame';

export default Frame;
